import { render, staticRenderFns } from "./CharacterLibrary.vue?vue&type=template&id=5def0e71&"
import script from "./CharacterLibrary.vue?vue&type=script&lang=ts&"
export * from "./CharacterLibrary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports